module.exports = __webpack_public_path__ + "img/valet-xavier.25e92ee1.jpeg";